export default __webpack_public_path__ + "static/media/various-work-tools-worktop.60fbe7eb.webp";